import { render, staticRenderFns } from "./productFeature.vue?vue&type=template&id=2d31972b&"
import script from "./productFeature.vue?vue&type=script&lang=js&"
export * from "./productFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports